import {JanusInstance, JanusStatus, PluginStatus} from "../../../constants/Janus";
import Janus from "../../../utils/Janus/janus";
import {useCallback, useEffect, useReducer} from "react";
import {initVideoSubState, videoRoomSubReducer} from "../../../store/reducers/VideoRoom/Subscriber";
import {VideoSubEvent} from "../../../constants/Janus/VideoRoom/Subscriber";
import {newRemoteFeed} from "../../../utils/Janus/VideoRoom/vsubscriber";

interface useVRoomSubProps {
    janusInstance: JanusInstance
    janusStatus: JanusStatus
    JanusModule?: any

    reconnect?: boolean
    reconnectDuration?: number
}

export const useVRoomSub = ({
    janusInstance,
    janusStatus,
    reconnect,
    reconnectDuration = 3000,
    JanusModule = Janus,
}: useVRoomSubProps) => {
    const [videoSub, dispatch] = useReducer(videoRoomSubReducer, initVideoSubState);

    useEffect(() => {
        const videoId: string = "videoroom-" + JanusModule.randomString(12);
        dispatch({type: VideoSubEvent.SET, payload: {key: "opaqueId", value: videoId}});
    }, [])

    const newFeed = useCallback((room: number, id: number, pvtId: number, display: any, audio: any, video: any) => {
        dispatch({type: VideoSubEvent.SET, payload: {key: "pluginStatus", value: PluginStatus.Attaching}});
        const videoId: string = "videoroom-" + JanusModule.randomString(12);
        newRemoteFeed(JanusModule, janusInstance, videoId, room, id , pvtId, display, audio, video,
            (remoteFeed: any, eventType: VideoSubEvent, payload: any) => {
                dispatch({type: VideoSubEvent.SET, payload: {key: "remoteFeed", value: remoteFeed}});
                switch (eventType) {
                    case VideoSubEvent.SUCCESS: {
                        dispatch({ type: VideoSubEvent.SUCCESS });
                        break;
                    }
                    case VideoSubEvent.ERROR: {
                        dispatch({ type: VideoSubEvent.ERROR, payload });
                        break;
                    }
                    case VideoSubEvent.ATTACHED: {
                        dispatch({ type: VideoSubEvent.ATTACHED });
                        break;
                    }
                    case VideoSubEvent.ICE_STATE: {
                        dispatch({ type: VideoSubEvent.ICE_STATE, payload });
                        break;
                    }
                    case VideoSubEvent.WEBRTC_STATE: {
                        dispatch({ type: VideoSubEvent.WEBRTC_STATE, payload });
                        break;
                    }
                    case VideoSubEvent.ON_REMOTE_STREAM: {
                        dispatch({ type: VideoSubEvent.ON_REMOTE_STREAM, payload });
                        break;
                    }
                    case VideoSubEvent.ON_CLEAN_UP: {
                        dispatch({ type: VideoSubEvent.ON_CLEAN_UP });
                        break;
                    }
                }
            })
    }, [JanusModule, janusInstance, videoSub.opaqueId])

    return {
        janusModule: JanusModule,
        janusInstance: janusInstance,
        ...videoSub,
        newFeed
    }
}